import { css } from 'styled-components';
import {
  BreakpointQueryName,
  getSpacing,
  SpacingName,
  ThemedFunctor,
} from '@doveit/lego';

export const item: ThemedFunctor = ({ theme }) => css`
  position: relative;
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;

    &::after {
      display: none;
    }
  }

  &::after {
    content: '';
    position: absolute;
    display: block;
    height: 1px;
    background-color: ${theme.palettes.neutrals.light};
    left: 4.5rem;
    right: 0;
    bottom: 0;

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      left: 9.5rem;
    }
  }
`;
